import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {IdNome} from '../../shared/model/id-nome.model';
import {
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate
} from '@angular/material/datepicker';
import {MatFormField, MatLabel, MatSuffix} from '@angular/material/input';
import {provideNativeDateAdapter} from '@angular/material/core';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-modal-filtro-documento',
  imports: [
    MatDateRangeInput,
    MatDateRangePicker,
    MatDatepickerToggle,
    MatEndDate,
    MatFormField,
    MatLabel,
    MatStartDate,
    MatSuffix,
    ReactiveFormsModule,
    MatButton,
    MatIcon
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './modal-filtro-documento.component.html',
  styleUrl: './modal-filtro-documento.component.css'
})
export class ModalFiltroDocumentoComponent {
  coligadaSelecionada?: IdNome;
  tipoDocumentoSelecionada?: IdNome;
  parceiroSelecionada?: IdNome;

  constructor(
    private dialog: MatDialogRef<ModalFiltroDocumentoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      filtro: FormGroup<{
        dataInicial: FormControl<Date | null>,
        dataFinal: FormControl<Date | null>,
        coligada?: FormControl<IdNome | null>,
        tipoDocumento?: FormControl<IdNome | null>,
        parceiro?: FormControl<IdNome | null>,
      }>,
      coligadas: IdNome[];
      tiposDocumentos: IdNome[];
      parceiros: IdNome[];
    },
  ) { }

  filtrar() {
    this.dialog.close(this.data.filtro);
  }

  verificarSelecionado(selecionada: IdNome | undefined, item: IdNome) {
    return !!selecionada && selecionada.id === item.id;
  }

  adicionarNoFiltro(item: IdNome, control: string) {
    this.data.filtro.get(control)?.patchValue(item);
  }
}
